// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { css } from 'glamor';

const container = css({
    backgroundColor: 'rgb(228, 65, 34)',
    padding: '15px',
    textAlign: 'center',
    verticalAlign: 'sub',
});

const smallContainerRule = css({
    fontSize: '0.7em',
    padding: '7px',
});

const scoreRule = css({
    color: '#fff',
    fontSize: '2em',
    fontWeight: 700,
    lineHeight: '6%',
});

const maxScoreRule = css({
    fontSize: '1.2em',
    fontWeight: 300,
});

const text = css({
    verticalAlign: 'sub',
});

@observer
export default class Score extends React.Component {
    props: {
        score: number,
        maxScore: number,
        small?: boolean,
    };

    render() {
        const { score, maxScore, small } = this.props;
        const smallContainer = small ? smallContainerRule : null;

        return (
            <span { ...container } { ...smallContainer }>
                <span { ...text }>
                    <span { ...scoreRule }>
                        {typeof score === 'number' ? score : '-'}
                    </span>
                    <span { ...scoreRule } { ...maxScoreRule }>
                        {`/${maxScore}`}
                    </span>
                </span>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/Score/index.js